import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import appStoreIcon from '../images/app-store.svg'
import googlePlayIcon from '../images/google-play.svg'

const ActionBtn = ({ appStoreReferrer }) => {
	const baseGooglePlayUrl =
		'https://play.google.com/store/apps/details?id=com.guppir.whispr'
	const [googlePlayUrl, setGooglePlayUrl] = useState(baseGooglePlayUrl)

	useEffect(() => {
		const queryString = window.location.search

		// Append the query string to the Google Play URL with `referrer` prefix
		if (queryString) {
			setGooglePlayUrl(
				`${baseGooglePlayUrl}&referrer=${encodeURIComponent(
					queryString.substring(1)
				)}`
			)
		}
	}, [])

	const appStoreUrl = `https://apps.apple.com/app/apple-store/id1612446646?${
		appStoreReferrer ? `${appStoreReferrer}` : ''
	}`

	return (
		<ButtonGroup>
			<DownloadButton as='a' href={appStoreUrl}>
				<img src={appStoreIcon} alt='app-store-icon' />
			</DownloadButton>
			<DownloadButton as='a' href={googlePlayUrl}>
				<img src={googlePlayIcon} alt='google-play-icon' />
			</DownloadButton>
		</ButtonGroup>
	)
}

const ButtonGroup = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 15px;
	margin-bottom: 15px;
	@media (max-width: 768px) {
		padding-top: 65px;
	}
`

const DownloadButton = styled.button`
	border-radius: 10px;
	height: 60px;
	cursor: pointer;
	transition: all 0.3s ease;
	&:hover {
		box-shadow: 0 0 10px #efb1ff;
	}
`
export default ActionBtn
